'use client';
import { useUser } from '../contexts/UserContext';
import usePresence from '../contexts/usePresence';

export default function PresenceWrapper() {
  const { user } = useUser();

  usePresence(!!user?.id);

  return null;
}
